'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonDynamicSlider from '../CommonDynamicSlider';
import cn from './style.module.scss';
export default function WestminsterTowerStory(
  props: MarketingPageComponentProps
) {
  const westminsterBannerStory =
    props?.locale?.section?.westminsterTowerWelcomeSlider ?? [];
  return (
    <Stack component="section" className={cn.westminsterTowerStory}>
      <CommonDynamicSlider
        data={westminsterBannerStory}
        className={cn.makeWorldStoryElement}
      />
    </Stack>
  );
}
